import { render, staticRenderFns } from "./forgetPsw.vue?vue&type=template&id=87b15fd4&scoped=true&"
import script from "./forgetPsw.vue?vue&type=script&lang=js&"
export * from "./forgetPsw.vue?vue&type=script&lang=js&"
import style0 from "./forgetPsw.vue?vue&type=style&index=0&id=87b15fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b15fd4",
  null
  
)

export default component.exports